import { updateFormErrors } from "./updateFormErrors";


export function checkInlineDoubleEmail(newValue) {
  if (!newValue) {
    return;
  }

  const formIDs = [ 'register-email-form' ];

  let validates = true;

  formIDs.forEach(function (formID) {
    const formObj = document.getElementById(formID);

    if (!formObj.checkValidity()) {
      validates = false;
    }
  });

  if (!register_email_form.emailRepeat) {
    return;
  }

  const repeatEmailFormElement = angular.element(register_email_form.emailRepeat).controller('ngModel');

  if (!repeatEmailFormElement) {
    return;
  }

  if (repeatEmailFormElement.$modelValue) {
    updateFormErrors('register-email-form');
  }

  repeatEmailFormElement.$validate();
  repeatEmailFormElement.$setValidity(
    'doubleEmail', validates
  );

}
